import { gqTools } from '../index'
import groupsGraphQl from './graphql/groups.graphql'

export class MenuApi {
  static async getGroups () {
    try {
      const client = await gqTools.getClient('menuSchema')
      return await client.query({
        query: gqTools.gql`${groupsGraphQl}`
      })
    } catch (e) {
      throw new Error(e.message)
    }
  }
}